var map = {
	"./data1.json": "a1a7",
	"./data2.json": "cbb3",
	"./data3.json": "f4d6",
	"./data4.json": "d449",
	"./data5.json": "93b4",
	"./data5_1.json": "e537",
	"./data6.json": "a843",
	"./data6_1.json": "3539",
	"./data7.json": "f630",
	"./data7_1.json": "2d73",
	"./data8.json": "a210"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2a0c";